/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { AndroidProto } from './android-proto';
import { Endianness } from './endianness';
import { FSFBDetectedFrameworks } from './fsfbdetected-frameworks';
import { IOSProto } from './iosproto';
import { MobileMockProto } from './mobile-mock-proto';
import { SessionFlags } from './session-flags';

export class SessionRequestProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SessionRequestProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSessionRequestProto(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionRequestProto,
  ): SessionRequestProto {
    return (obj || new SessionRequestProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSessionRequestProto(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionRequestProto,
  ): SessionRequestProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SessionRequestProto()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  fsOrgId(): string | null;
  fsOrgId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsOrgId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fsUserId(): string | null;
  fsUserId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsUserId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fsBuildId(): string | null;
  fsBuildId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsBuildId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  timestamp(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  endianness(): Endianness {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : Endianness.BIG;
  }

  ios(obj?: IOSProto): IOSProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new IOSProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  android(obj?: AndroidProto): AndroidProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new AndroidProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  forceNewSession(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  mobileMock(obj?: MobileMockProto): MobileMockProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new MobileMockProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  fsPluginVersion(): string | null;
  fsPluginVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fsPluginVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  gitHash(): string | null;
  gitHash(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  gitHash(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  sessionFlags(index: number): SessionFlags | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  sessionFlagsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  sessionFlagsArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  detectedFrameworks(index: number): FSFBDetectedFrameworks | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  detectedFrameworksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  detectedFrameworksArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  pageStart(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('0');
  }

  isEntryPage(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  pastSessionId(): string | null;
  pastSessionId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  pastSessionId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSessionRequestProto(builder: flatbuffers.Builder) {
    builder.startObject(20);
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(0, version, 0);
  }

  static addFsOrgId(builder: flatbuffers.Builder, fsOrgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, fsOrgIdOffset, 0);
  }

  static addFsUserId(builder: flatbuffers.Builder, fsUserIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, fsUserIdOffset, 0);
  }

  static addFsBuildId(builder: flatbuffers.Builder, fsBuildIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, fsBuildIdOffset, 0);
  }

  static addTimestamp(builder: flatbuffers.Builder, timestamp: bigint) {
    builder.addFieldInt64(4, timestamp, BigInt('0'));
  }

  static addEndianness(builder: flatbuffers.Builder, endianness: Endianness) {
    builder.addFieldInt8(5, endianness, Endianness.BIG);
  }

  static addIos(builder: flatbuffers.Builder, iosOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, iosOffset, 0);
  }

  static addAndroid(builder: flatbuffers.Builder, androidOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, androidOffset, 0);
  }

  static addForceNewSession(builder: flatbuffers.Builder, forceNewSession: boolean) {
    builder.addFieldInt8(8, +forceNewSession, +false);
  }

  static addMobileMock(builder: flatbuffers.Builder, mobileMockOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, mobileMockOffset, 0);
  }

  static addFsPluginVersion(
    builder: flatbuffers.Builder,
    fsPluginVersionOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, fsPluginVersionOffset, 0);
  }

  static addGitHash(builder: flatbuffers.Builder, gitHashOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, gitHashOffset, 0);
  }

  static addSessionFlags(builder: flatbuffers.Builder, sessionFlagsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, sessionFlagsOffset, 0);
  }

  static createSessionFlagsVector(
    builder: flatbuffers.Builder,
    data: SessionFlags[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startSessionFlagsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addDetectedFrameworks(
    builder: flatbuffers.Builder,
    detectedFrameworksOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, detectedFrameworksOffset, 0);
  }

  static createDetectedFrameworksVector(
    builder: flatbuffers.Builder,
    data: FSFBDetectedFrameworks[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDetectedFrameworksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addPageStart(builder: flatbuffers.Builder, pageStart: bigint) {
    builder.addFieldInt64(15, pageStart, BigInt('0'));
  }

  static addIsEntryPage(builder: flatbuffers.Builder, isEntryPage: boolean) {
    builder.addFieldInt8(16, +isEntryPage, +false);
  }

  static addPastSessionId(builder: flatbuffers.Builder, pastSessionIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, pastSessionIdOffset, 0);
  }

  static endSessionRequestProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
